import React, { Component } from 'react';
import { Button, Image, Glyphicon } from 'react-bootstrap';
import AuthService from "../../services/auth.service";
import { history } from '../../helpers';
import '../../content/css/HowItWorks.css';

const img = require("../../content/images/purple_brush_highlight.png");

export default class HowItWorks extends Component {
    constructor(props) {
        super(props);

        this.authService = new AuthService();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        history.push("/upload");
    }

    render() {
        let isGuest = this.authService.isGuest();
        return (
            <div className="how-it-works">
                <h3>How it Works</h3>
                <div className="boxes">
                    <div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="tags" />
                                <h4>Upload your contract</h4>
                                <p>Our service can handle a range of different contracts, including NDAs and EULAs.</p>
                            </div>
                        </div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="wrench" />
                                <h4>Tell the robot what to look for</h4>
                                <p>Want to tailor exactly what clauses to look for? We have that covered.</p>
                            </div>
                        </div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="duplicate" />
                                <h4>Scroll through the analysis</h4>
                                <p>See how different versions of a contract differ from each other. What's been changed?</p>
                            </div>
                        </div>
                        <div className="box">
                            <div>
                                <Glyphicon glyph="duplicate" />
                                <h4>Export feedback</h4>
                                <p>See how different versions of a contract differ from each other. What's been changed?</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Button onClick={this.handleClick}>Continue</Button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Misc/HowItWorks.js